<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>分类管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 分类树 -->
    <div class="content">
      <el-form inline label-position="right" label-width="60px" size="small" class="query-form">
        <el-form-item style="margin-left:15px;">
          <el-tooltip content="添加" placement="top">
            <el-button type="success" size="small" @click="addClick()">添加分类</el-button>
          </el-tooltip>
          <el-tooltip content="删除" placement="top">
            <el-button type="primary" size="small" @click="delFilter()">删除选中</el-button>
          </el-tooltip>
        </el-form-item>
      </el-form>

      <el-card class="box-card table">
        <div class="clearfix" slot="hander">
          <span>商品分类列表</span>
        </div>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-tree
              :data="treelist"
              ref="tree"
              show-checkbox
              node-key="id"
              default-expand-all
              highlight-current
              :check-strictly="true"
              :props="defaultProps"
              :expand-on-click-node="false"
              :render-content="renderContent"
            ></el-tree>
          </el-col>
        </el-row>
        <div style="height:30px;"></div>
      </el-card>

      <el-dialog :title="form.id>0?'编辑分类':'添加分类'" :visible.sync="dialogVisible">
        <el-form
          :model="form"
          ref="form"
          label-width="100px"
          :status-icon="true"
          @submit.native.prevent="submitForm(form)"
        >
          <!-- <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item prop="parentID" label="上一级">
                <el-select v-model="form.parentID" clearable placeholder="请选择上一级分类">
                  <el-option
                    v-for="item in parentlist"
                    :label="item.name"
                    :key="item.id"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row> -->

          <el-form-item prop="name" label="分类名称" :rules="[{required:true,message:'不能为空'}]">
            <el-input v-model="form.name" placeholder="请输入分类名称"></el-input>
          </el-form-item>

          <el-form-item label="图标">
            <el-button
              id="uploadBtn2"
              class="uploader uploader-warning"
              @click="dialogOpended()"
            >上传图片</el-button>
            <img
              id="relativeName"
              :src="domain+form.logo"
              style="height:40px;position:relative;left:10px;top:20px;"
              v-if="form.logo"
            />
            <span
              class="uploadslot"
              style="margin-left:20px;font-size:12px;color:red;"
            >*图片尺寸（方图）：推荐300*300</span>
          </el-form-item>

          <el-form-item prop="sort" label="排序">
            <el-input v-model="form.sort" placeholder="请输入排序"></el-input>
          </el-form-item>

          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item prop="isEnable" label="是否可用" :rules="[{required:true,message:'不能为空'}]">
                <el-switch v-model="form.isEnable"></el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item prop="summary" label="备注">
            <el-input type="textarea" v-model="form.summary" placeholder="请输入备注"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="submiting" native-type="submit">保存</el-button>
            <el-button @click="dialogVisible=false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import "../../../public/lib/cover/Cover3.0.min.css";
import "../../../public/lib/cover/Cover3.0.min.js";
export default {
  data() {
    return {
      domain: url.getDomain(),
      form: {
        isEnable: true
      },
      loading: false,
      submiting: false,
      defaultProps: {
        children: "children",
        label: "label"
      },
      parentlist: [],
      treelist: [],
      dialogVisible: false
    };
  },
  methods: {
    //   获取父类
    getParentList: function() {
      var _this = this;
      var link = url.getMall("getcatebyParent");
      $.get(link, {}, data => {
        _this.parentlist = data;
      });
    },
    // 获取树结构
    getTreeList: function() {
      var _this = this;
      var link = url.getMall("getcatetree");
      $.get(link, {}, data => {
        _this.treelist = data;
      });
    },
    // 获取对象
    getModel: function(node, nodeChecked) {
      var _this = this;
      var id = node.id;
      if (nodeChecked) {
        var link = url.getMall("getmodel_cate");
        $.get(link, { id: id }, data => {
          _this.form = data;
        });
      } else {
        _this.form = {};
      }
    },
    // 删除
    delFilter: function() {
      var _this = this;
      var link = url.getMall("delete_cate");
      var idlist = this.$refs.tree.getCheckedKeys().toString();
      if (!idlist) {
        _this.$message({
          type: "error",
          message: "请选择选项"
        });
        return;
      }

      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          $.post(link, { idList: idlist }, res => {
            if (res.status) {
              _this.getTreeList();
              _this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    remove: function(node, data) {
      var _this = this;
      var link = url.getMall("delete_cate");
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          $.post(link, { idList: data.id }, res => {
            if (res.status) {
              _this.getTreeList();
              _this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //编辑处理
    edit(node, data) {
      var _this = this;
      _this.dialogVisible = true;
      var id = data.id;
      var link = url.getMall("getmodel_cate");
      $.get(link, { id: id }, data => {
        _this.form = data;
      });
      return false;
    },
    // 添加
    addClick: function() {
      this.form = {};
      this.form.isEnable = true;
      this.dialogVisible = true;
    },
    // 上传
    dialogOpended: function() {
      var _this = this;
      if ($("#uploadBtn2 input").length == 0) {
        $("#uploadBtn2").uploader({
          url: url.getUpload(),
          text: "上传图片",
          fileExts: "jpg;png",
          type: "dialog",
          maxSize: 1024 * 1024 * 1,
          subfolder: "content",
          more: false,
          auto: true,
          coverParams: {
            title: "上传图片",
            targetWidth: 300,
            targetHeight: 300
          },
          onSuccess: function(data) {
            var src = url.getDomain + data.relativeName;
            _this.$set(_this.form, "logo", data.relativeName);
          }
        });
      }
    },
    // 保存
    submitForm: function(formName) {
      var _this = this;
      var link = url.getMall("save_cate");
      var info = _this.form;

      this.$refs.form.validate(valid => {
        if (valid) {
          _this.submiting = true;

          // 提交后台   添加或修改
          $.post(link, info, res => {
            _this.submiting = false;
            _this.dialogVisible=false;
            if (res.status) {
              _this.getTreeList();
              _this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    renderContent(h, { node, data, store }) {
      return (
        <span class="custom-tree-node">
          <span>{node.label}</span>
          <span class="pull-right">
            <el-button
              size="mini"
              type="text"
              on-click={() => this.edit(node, data)}
            >
              编辑
            </el-button>
            <el-button
              size="mini"
              type="text"
              on-click={() => this.remove(node, data)}
            >
              删除
            </el-button>
          </span>
        </span>
      );
    }
  },
  mounted() {
    //   父类
    this.getParentList();
    // 树结构
    this.getTreeList();
  }
};
</script>

<style>
.el-row {
  margin: 20px 0px;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #fff;
  border: 1px solid #e7ecf1 !important;
  box-shadow: 0 2px 3px 2px rgba(0, 0, 0, 0.03);
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  padding: 12px 20px 15px;
  border-radius: 4px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.font-green-sharp {
  color: #2ab4c0 !important;
}
.uppercase {
  text-transform: uppercase !important;
}
.bold {
  font-weight: 700 !important;
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}
.el-button-group {
  display: block;
  float: right;
}
.el-tree__empty-block {
  font-size: 14px;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 15px;
  padding: 5px 8px 5px 3px;
}
.el-tree-node__content {
  height: 30px;
}
</style>